var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 209,
    viewBox: "0 0 291 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.6529 82.3125H140.335L169.176 132.274L140.335 182.223H82.6529L53.7989 132.274L82.6529 82.3125Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.315 18.4375H190.774L209.004 50.017L190.774 81.5883H154.315L136.077 50.017L154.315 18.4375Z",
    fill: "#E2F2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4255_381356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.3364 124.223C94.9359 124.223 93.4745 123.797 92.2567 122.823C89.334 120.57 88.786 116.369 91.0389 113.446L92.5612 111.437C88.9078 108.697 83.9148 104.8 79.0436 100.537C64.0646 87.4459 58.7063 78.1906 61.5682 70.5794C66.3785 57.9752 86.2895 46.7105 88.5424 45.4927C90.2474 44.5794 92.1958 44.3967 94.0225 45.0665L104.313 48.7199C107.784 49.9377 109.61 53.7737 108.393 57.3054C107.175 60.7761 103.339 62.6028 99.8071 61.385L92.5003 58.7667C85.4979 63.029 76.608 69.8487 74.3551 74.9635C74.6595 76.0595 76.7298 81.0525 89.5776 92.0127C97.615 98.8324 105.774 104.495 105.835 104.556C107.357 105.591 108.332 107.235 108.636 109.001C108.941 110.828 108.453 112.654 107.357 114.116L101.634 121.605C100.294 123.31 98.3457 124.223 96.3364 124.223Z",
    fill: "#78A1BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.759 124.223C188.16 124.223 189.621 123.797 190.839 122.823C193.761 120.57 194.309 116.369 192.057 113.446L190.534 111.437C194.188 108.697 199.181 104.8 204.052 100.537C218.97 87.4459 224.389 78.1906 221.466 70.5794C216.717 57.9752 196.745 46.7105 194.492 45.4927C192.787 44.5794 190.839 44.3967 189.012 45.0665L178.722 48.7199C175.251 49.9377 173.424 53.7737 174.642 57.3054C175.86 60.7761 179.696 62.6028 183.227 61.385L190.534 58.7667C197.537 63.029 206.427 69.8487 208.68 74.9635C208.375 76.0595 206.305 81.0525 193.457 92.0127C185.359 98.9541 177.199 104.617 177.078 104.678C175.555 105.713 174.581 107.357 174.277 109.123C173.972 110.949 174.459 112.776 175.555 114.238L181.279 121.727C182.74 123.31 184.75 124.223 186.759 124.223Z",
    fill: "#78A1BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.956 129.421C159.933 129.437 159.911 129.453 159.889 129.47L161.061 130.988C159.889 129.47 159.888 129.471 159.887 129.471L159.885 129.473L159.881 129.477L159.868 129.486L159.834 129.513C159.807 129.535 159.771 129.564 159.727 129.601C159.64 129.674 159.521 129.777 159.375 129.909C159.083 130.174 158.685 130.56 158.222 131.069C157.298 132.088 156.111 133.606 155.011 135.651C152.797 139.763 150.969 145.934 152.223 154.289C152.316 154.911 152.708 155.447 153.271 155.725L171.097 164.509H141.697H112.298L130.124 155.725C130.683 155.449 131.074 154.919 131.17 154.302C132.488 145.917 130.694 139.743 128.493 135.632C127.399 133.589 126.215 132.074 125.291 131.059C124.828 130.551 124.43 130.167 124.138 129.903C123.992 129.771 123.872 129.669 123.784 129.596C123.74 129.559 123.704 129.53 123.677 129.509L123.642 129.481L123.63 129.472L123.625 129.468L123.623 129.466C123.622 129.466 123.621 129.465 122.456 130.988L123.621 129.465C123.601 129.45 123.581 129.435 123.561 129.421L119.859 126.812C119.857 126.81 119.855 126.808 119.853 126.807C113.7 122.394 108.956 116.31 106.356 109.201L106.352 109.191C103.693 102.04 102.332 94.4118 102.332 86.7214V48.8478C102.332 47.2166 103.654 45.8943 105.285 45.8943H141.758H178.231C179.863 45.8943 181.185 47.2166 181.185 48.8478V86.7214C181.185 94.3491 179.825 101.979 177.163 109.196L177.161 109.201C174.557 116.318 169.871 122.398 163.667 126.805C163.666 126.805 163.665 126.806 163.664 126.807L159.956 129.421Z",
    fill: "#E2F2FF",
    stroke: "#9DBDD1",
    strokeWidth: 3.83547,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.223 46.4219H158.658V79.9934C158.658 87.2841 159.252 87.6233 157.132 101.103C155.013 114.582 149.672 119.669 145.264 126.79C141.737 132.487 143.794 148.493 145.264 155.784C144.246 135.692 149.163 131.198 157.132 122.466C165.101 113.734 168.068 107.122 170.273 101.103C172.036 96.2874 172.307 89.7709 172.223 87.1146V46.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.759 166.484H104.129V192.145C104.129 194.486 106.747 196.35 110.035 196.35H141.759H173.483C176.771 196.35 179.389 194.486 179.389 192.145V166.484H141.759Z",
    fill: "#78A1BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.956 129.421C159.933 129.437 159.911 129.453 159.889 129.47L161.061 130.988C159.889 129.47 159.888 129.471 159.887 129.471L159.885 129.473L159.881 129.477L159.868 129.486L159.834 129.513C159.807 129.535 159.771 129.564 159.727 129.601C159.64 129.674 159.521 129.777 159.375 129.909C159.083 130.174 158.685 130.56 158.222 131.069C157.298 132.088 156.111 133.606 155.011 135.651C152.797 139.763 150.969 145.934 152.223 154.289C152.316 154.911 152.708 155.447 153.271 155.725L171.097 164.509H141.697H112.298L130.124 155.725C130.683 155.449 131.074 154.919 131.17 154.302C132.488 145.917 130.694 139.743 128.493 135.632C127.399 133.589 126.215 132.074 125.291 131.059C124.828 130.551 124.43 130.167 124.138 129.903C123.992 129.771 123.872 129.669 123.784 129.596C123.74 129.559 123.704 129.53 123.677 129.509L123.642 129.481L123.63 129.472L123.625 129.468L123.623 129.466C123.622 129.466 123.621 129.465 122.456 130.988L123.621 129.465C123.601 129.45 123.581 129.435 123.561 129.421L119.859 126.812C119.857 126.81 119.855 126.808 119.853 126.807C113.7 122.394 108.956 116.31 106.356 109.201L106.352 109.191C103.693 102.04 102.332 94.4118 102.332 86.7214V48.8478C102.332 47.2166 103.654 45.8943 105.285 45.8943H141.758H178.231C179.863 45.8943 181.185 47.2166 181.185 48.8478V86.7214C181.185 94.3491 179.825 101.979 177.163 109.196L177.161 109.201C174.557 116.318 169.871 122.398 163.667 126.805C163.666 126.805 163.665 126.806 163.664 126.807L159.956 129.421Z",
    stroke: "#9DBDD1",
    strokeWidth: 3.83547,
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.59 11.8281V25.0337",
    stroke: "#C1A2E7",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226.59 33.8047V47.0026",
    stroke: "#C1A2E7",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M244.175 29.0078H230.977",
    stroke: "#C1A2E7",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.202 29.0078H209.004",
    stroke: "#C1A2E7",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.129 103.203V108.491",
    stroke: "#E4D6F5",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.129 112V117.284",
    stroke: "#E4D6F5",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244.167 110.078H238.883",
    stroke: "#E4D6F5",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M235.37 110.078H230.086",
    stroke: "#E4D6F5",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7344 89.1797L49.8397 108.285",
    stroke: "#9DBDD1",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8397 89.1797L30.7344 108.285",
    stroke: "#9DBDD1",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2891 85.2188V112.237",
    stroke: "#9DBDD1",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7965 98.7266H26.7812",
    stroke: "#9DBDD1",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.494 30.2143L64.9861 33.3083L53.494 36.4023C45.3688 38.5905 39.0225 44.9368 36.8343 53.062L33.7403 64.554L30.6463 53.062C28.4581 44.9368 22.1118 38.5905 13.9921 36.4023L2.5 33.3083L13.9921 30.2143C22.1173 28.0261 28.4636 21.6798 30.6518 13.5546L33.7458 2.0625L36.8398 13.5546C39.0225 21.6798 45.3688 28.0261 53.494 30.2143Z",
    fill: "#E4D6F5",
    stroke: "#C1A2E7",
    strokeWidth: 3.83547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M279.724 65.3053L285.782 66.936C287.192 67.3156 287.192 69.3168 285.782 69.6964L279.724 71.3271C271.823 73.4529 265.646 79.6298 263.511 87.5402L261.88 93.5983C261.5 95.0088 259.499 95.0088 259.12 93.5983L257.489 87.5402C255.363 79.639 249.186 73.4621 241.276 71.3271L235.218 69.6964C233.807 69.3168 233.807 67.3156 235.218 66.936L241.276 65.3053C249.177 63.1794 255.354 57.0026 257.489 49.0921L259.12 43.0341C259.499 41.6236 261.5 41.6236 261.88 43.0341L263.511 49.0921C265.646 57.0026 271.823 63.1794 279.724 65.3053Z",
    fill: "#9DBDD1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.027 56.3125V84.0724",
    stroke: "white",
    strokeWidth: 8.13854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.027 96.2891V96.6043",
    stroke: "white",
    strokeWidth: 8.13854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4255_381356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161.419,
    height: 168.665,
    fill: "white",
    transform: "translate(60.8359 39.7734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.36703421aaa72fce750973edc7b40a8b.svg";
export { ForwardRef as ReactComponent };